import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoOperStatusTerminais(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaooperstatusterminais/FIND_OPERSTATUSTERMINAIS':
      case '@operacaooperstatusterminais/UPDATE_OPERSTATUSTERMINAIS':
      case '@operacaooperstatusterminais/DELETE_OPERSTATUSTERMINAIS':
      case '@operacaooperstatusterminais/STORE_OPERSTATUSTERMINAIS':
      case '@operacaooperstatusterminais/OPERSTATUSTERMINAIS_IN_REQUEST':
      case '@operacaooperstatusterminais/REFRESH': {
        draft.loading = true;
        break;
      }

      case '@operacaooperstatusterminais/SUCCESS_REMOVE':
      case '@operacaooperstatusterminais/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaooperstatusterminais/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaooperstatusterminais;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaooperstatusterminais/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaooperstatusterminais;
        break;
      }

      case '@operacaooperstatusterminais/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
